<div class="storage-content">
  <p-card>
    <ng-template pTemplate="header">
      <span class="p-card-title">Sort Summary</span>
      <span>
        <p-toggleButton [formControl]="showZeroRows" offLabel="Show All Rows" onLabel="Hide Rows"></p-toggleButton>
      </span>
    </ng-template>
    <div *ngIf="loading" class="centered">
      <i class="pi pi-spin pi-spinner"></i>
      Calculating...
    </div>
    <p-table *ngIf="(sortSummary | async) && !loading"
      [value]="filteredRows | async"
      styleClass="scrolltable"
      [scrollable]="true"
      scrollHeight="flex">
        <ng-template pTemplate="header">
        <tr>
          <th>Pallet Type</th>
          <th>Beginning <br />Inventory</th>
          <th>Received</th>
          <th>Shipped</th>
          <th>Net Reclass</th>
          <th title="Count">Ending <br />Inventory</th>
          <th>
            <span>
              Sorted Out/ <br />
              <span class="scrap-highlight">Scrapped</span>/<span class="tdwn-highlight">Teardown</span>
            </span>
          </th>
          <th><span>Sorted In/ <br /><span class="highlight">Repaired</span></span></th>
          <th *ngIf="doesTransfers() | async">Internal <br />Transfers</th>
          <th>Balance</th>
          <th>Shift <br />Variance</th>
          <th>Weekly <br />Variance</th>
        </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
        <tr>
            <td>{{ (getProduct(row.productId) | async) || '&lt;unknown&gt;' }}</td>
            <td [attr.title]="getBeginningInventoryTooltip(row)">{{ getBeginningInventory(row) }}</td>
            <td title="Loads: {{row.receivedLoads}}">{{ row.receivedUnits }}</td>
            <td [attr.title]="getShippedTooltip(row)">{{ getShippedTotal(row) }}</td>
            <td [attr.title]="getReclassTooltip(row) | async">{{ row.netReclass }}</td>
            <td [attr.title]="getEndingInventoryTooltip(row)">{{ getEndingInventory(row) }}</td>
            <td [class.scrap-highlight]="row.sortOutIsScrap" [class.tdwn-highlight]="row.sortOutIsTeardown"
                [attr.title]="getSortedQuantityTooltip(row) | async">
              {{ getSortedQuantity(row) }}
            </td>
            <td [class.highlight]="row.sortInIsRepairs"
                [attr.title]="getSortedInQuantityTooltip(row) | async">
              {{ row.sortedIn }}
            </td>
            <td *ngIf="doesTransfers() | async" [title]="getInternalTransfersTooltip(row)">{{ getTransfersTotal(row) }}</td>
            <td [attr.title]="getBalanceTooltip(row)">{{ row.endingBalance }}</td>
            <td [class.hasVariance]="row.shiftVariance !== 0">{{ row.shiftVariance }}</td>
            <td [class.hasVariance]="row.weeklyVariance !== 0">{{ row.weeklyVariance }}</td>
        </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr class="totals">
            <td>Totals</td>
            <td>{{ sumTotal(getBeginningInventory) | async }}</td>
            <td>{{ sumTotal('receivedUnits') | async }}</td>
            <td>{{ sumTotal(getShippedTotal) | async }}</td>
            <td>{{ sumTotal('netReclass') | async }}</td>
            <td>{{ sumTotal(getEndingInventory) | async }}</td>
            <td>{{ sumTotal(getSortedQuantity) | async }}</td>
            <td>{{ sumTotal('sortedIn') | async }}</td>
            <td *ngIf="doesTransfers() | async">{{ sumTotal(getTransfersTotal) | async }}</td>
            <td>{{ sumTotal('endingBalance') | async }}</td>
            <td>{{ sumTotal('shiftVariance') | async }}</td>
            <td>{{ sumTotal('weeklyVariance') | async }}</td>
          </tr>
        </ng-template>
    </p-table>
  </p-card>
</div>
